{
  "appName": "AirPlx",
  "logoAlt": "Logo AirPlx",
  "errors": {
    "authRequired": "Authentification requise",
    "loginAgain": "Veuillez vous reconnecter pour accepter les invitations",
    "serviceUnavailable": "Service indisponible",
    "serviceTemporarilyUnavailable": "Service temporairement indisponible. Veuillez réessayer.",
    "emailRequired": "E-mail requis",
    "emailRequiredValidation": "L'e-mail de l'utilisateur est requis pour valider l'invitation",
    "inviteInvalid": "L'invitation n'est plus valide ou a déjà été utilisée",
    "invalidFBOInfo": "Informations FBO non valides dans l'invitation",
    "inviteCouldNotBeClaimed": "L'invitation n'a pas pu être utilisée",
    "acceptFailed": "Échec de l'acceptation de l'invitation"
  },
  "inviteStatus": {
    "pending": "En attente",
    "accepting": "Acceptation...",
    "tryAgain": "Réessayer",
    "accept": "Accepter"
  }
}
